<template>
  <FreeModal :name="name" class="search-form-error-modal-width">
    <template #header>
      <h2 class="text-text-neutral-primary text-center text-lg font-semibold">
        {{ errorTitle }}
      </h2>
    </template>
    <template #default="{ hide }">
      <FreeButton
        type="button"
        class="gray-button mt-6 w-full text-lg font-semibold"
        @click="hide"
      >
        {{ $t('general.ok') }}
      </FreeButton>
    </template>
  </FreeModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { FreeModal, FreeButton } from 'freedom-shared';
  import { controllerModel } from 'shared';

  const props = defineProps<{
    name: string;
  }>();

  const modalController = controllerModel.useModal();
  const errorTitle = computed(
    () => modalController.getParams(props.name).errorTitle,
  );
</script>

<style scoped>
  .search-form-error-modal-width {
    --free-ui-modal-width: 295px;
  }
</style>
